import httpRequest from '@/utils/request';

const loginUrl = '/Authenticate/login';
const profileUrl = '/User/profile';
const passwordUrl = '/User/password';
const registerUrl = '/Authenticate/register';
const smsCodeUrl = '/Authenticate/sms';

export const signIn = (loginData: IAuthenticate.IRequest.ILogin): Promise<IAuthenticate.IResponse.IData> => {
  return httpRequest.post(loginUrl, loginData);
};
export const updateProfile = (params: IAuthenticate.IRequest.IUpdateProfile): Promise<IResponseData.IBaseData> => {
  return httpRequest.put(profileUrl, params);
};
export const updatePassword = (params: IAuthenticate.IRequest.IUpdatePassword): Promise<IResponseData.IBaseData> => {
  return httpRequest.put(passwordUrl, params);
};
export const register = (params: IAuthenticate.IRequest.IRegister): Promise<IResponseData.IBaseData> => {
  return httpRequest.post(registerUrl, {
    mobile: params.mobile,
    password: params.password,
    smsCode: params.smsCode,
  }, {
    params: {
      id: params.id,
    },
  });
};
export const getSMS = (mobile: string): Promise<IResponseData.IBaseData> => {
  return httpRequest.get(smsCodeUrl, {
    params: {
      moblie: mobile, // api字段临时错误
      mobile,
    },
  });
};
